import React, { Component } from 'react'
import { selectAllDevices } from '../../containers/DeviceSelector/selectors'
import { connect } from 'react-redux'

const DeviceNameHOC = WrappedComponent => {
  class DeviceName extends Component {
    deviceName = (item, hideParens = false) => {
      const device = this.props.devices.find(
        device => device.phonefk === parseInt(item.phonefk, 10)
        )
        if (device) {
        return hideParens ? device.name_pretty : `(${device.name_pretty})`
      } else {
        return item.model
      }
    }

    generateProps = () => ({
      ...this.props,
      deviceName: this.deviceName
    })

    render() {
      return <WrappedComponent {...this.generateProps()} />
    }
  }

  const mapStateToProps = state => ({
    devices: selectAllDevices(state)
  })

  return connect(mapStateToProps)(DeviceName)
}

export default DeviceNameHOC



// WEBPACK FOOTER //
// ./src/hocs/DeviceNameHOC/index.js